import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Image,
  Text,
  useDisclosure,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Input,
  HStack,
  RadioGroup,
  Stack,
  Radio,
  // useDisclosure,
} from "@chakra-ui/react";
import { exportExcelLocal, exportFile, importFile, importWithToast } from "../../utils/tools";
import iconFile from "../../assets/images/timeKeeping/file.svg";
import toast from "react-hot-toast";
import { RadioControl } from "../../components/form/formControls";
import DeleteDialog from "../../components/dialog/delete";
import { commissionAnalystCall } from "../../api/commissionAnalyst";
import { IoArrowBackOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

export default function DeleteCommission() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [fileName, setFileName] = useState("");
  const [selectedValue, setSelectedValue] = useState(1);
  const inputFileRef = useRef(null);
  const navigate = useNavigate();

  const options = [
    { label: "Mới nhất", value: 1 },
    { label: "Theo tháng", value: 2 },
  ];

  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (fileExtension === "xlsx" || fileExtension === "csv") {
        setFileName(file.name);
      } else {
        alert("Vui lòng chọn file có định dạng .xlsx hoặc .csv");
        event.target.value = null;
        setFileName("");
      }
    }
  };

  const handleActionStateChange = (data) => {
    setSelectedValue(Number(data));
  };

  const handleExport1 = () => {
    const columnMapping = {
      codeApartment: "Mã Căn",
    };

    const data = [
      {
        codeApartment: "CODE1",
      },
      {
        codeApartment: "CODE2",
      },
    ];
    // try {
    //   exportFile(data, columnMapping, "file_mau_xoa_pdv_moi_nhat.xlsx");
    //   toast.success("Download file thành công");
    // } catch (error) {
    //   toast.error("Export lỗi");
    //   console.log(error);
    // }
    exportExcelLocal({
      data,
      mapping: columnMapping,
      filename: "file_mau_xoa_pdv_moi_nhat.xlsx",
      toastMessages: {
        success: "Download file thành công",
      },
    });
  };

  const handleExport2 = () => {
    const columnMapping = {
      codeApartment: "Mã Căn",
      month: "Tháng",
    };

    const data = [
      {
        codeApartment: "CODE1",
        month: "07/2025",
      },
      {
        codeApartment: "CODE2",
        month: "07/2025",
      },
    ];
    // try {
    //   exportFile(data, columnMapping, "file_mau_xoa_pdv_theo_thang.xlsx");
    //   toast.success("Download file thành công");
    // } catch (error) {
    //   toast.error("Export lỗi");
    //   console.log(error);
    // }
    exportExcelLocal({
      data,
      mapping: columnMapping,
      filename: "file_mau_xoa_pdv_theo_thang.xlsx",
      toastMessages: {
        success: "Download file thành công",
      },
    });
  };

  // const handleDelete = async () => {
  //   if (selectedValue === 2) {
  //     onOpen();
  //   } else {
  //     if (!inputFileRef.current || !inputFileRef.current.files[0]) {
  //       toast.error("Vui lòng chọn file để import.");
  //       return;
  //     }

  //     const fileEvent = { target: { files: inputFileRef.current.files } };

  //     const toastCreate = toast.loading("Đang thêm danh sách...");
  //     try {
  //       await importFile(
  //         fileEvent,
  //         {
  //           "Mã Căn": "codeApartment",
  //         },
  //         1,
  //         async (importedData) => {
  //           try {
  //             // console.log({importedData})
  //             await commissionAnalystCall.deleteCommission(importedData);
  //             toast.success(`Tải dữ liệu thành công`);
  //           } catch (error) {
  //             toast.error("API call failed");
  //             console.error("Lỗi khi bulkAdd:", error);
  //           }
  //         }
  //       );
  //     } catch (error) {
  //       toast.error("Import error");
  //       console.error("Lỗi khi importFile:", error);
  //     }
  //     toast.dismiss(toastCreate);
  //   }
  // };

  const handleDelete = async () => {
    if (selectedValue === 2) {
      onOpen();
      return;
    }

    await importWithToast({
      files: inputFileRef.current?.files,
      mapping: { "Mã Căn": "codeApartment" },
      typeValue: 1,
      minLoadingMs: 500,
      toastMessages: {
        loading: "Đang đọc file & xoá dữ liệu...",
        success: "Xoá dữ liệu thành công",
        error: "Xoá thất bại, vui lòng kiểm tra lại file.",
      },
      onData: async (importedData) => {
        return await commissionAnalystCall.deleteCommission(importedData);
      },
    });
  };


  const handleNavigate = (e) => {
    navigate(`/service-fee-management`);
  };

  return (
    <Box>
      <Flex
        onClick={handleNavigate}
        cursor={"pointer"}
        gap={"8px"}
        alignItems={"center"}
        mb={"24px"}
        ml={"24px"}
        mt={"24px"}
        w={"max-content"}
      >
        <IoArrowBackOutline fontSize={"24px"} />
        <Text
          fontSize={"20px"}
          lineHeight={"19px"}
          fontWeight={"600"}
          color={"var(--color-header-employee)"}
        >
          Quay lại
        </Text>
      </Flex>
      <Flex
        w={{ base: "100%" }}
        p={{ base: "64px 16px 16px" }}
        justifyContent={"center"}
      >
        <Box p="24px" w={"100%"} maxW={"800px"}>
          <RadioGroup
            onChange={handleActionStateChange}
            value={Number(selectedValue) || 0}
            mb={"16px"}
          >
            <Stack spacing="36px" direction="row" alignItems="center">
              {options.map((option, index) => (
                <Radio key={index} size="lg" value={option.value}>
                  {option.label}
                </Radio>
              ))}
            </Stack>
          </RadioGroup>
          <Flex p="24px 0" w={"100%"}>
            <HStack spacing="4" w={"100%"}>
              <Input
                type="text"
                placeholder="Chưa có file nào được chọn"
                value={fileName}
                isReadOnly
                cursor="not-allowed"
                bg="gray.100"
                color="gray.800"
                _placeholder={{ color: "gray.500" }}
              />
              <Button
                as="label"
                htmlFor="file-upload"
                bg="blue.500"
                color="white"
                px="4"
                py="2"
                borderRadius="md"
                cursor="pointer"
                _hover={{ bg: "blue.600" }}
                _active={{ bg: "blue.700" }}
              >
                Chọn file
              </Button>
              <Input
                id="file-upload"
                type="file"
                accept=".xlsx, .csv"
                onChange={handleFileChange}
                ref={inputFileRef}
                display="none"
              />
            </HStack>

            <Button
              display={"flex"}
              marginLeft={"8px"}
              alignItems={"center"}
              p={"10px 16px 10px 12px"}
              gap={"8px"}
              backgroundImage="var(--color-gradient-excel)"
              _hover={{
                backgroundImage: "var(--color-gradient-excel)",
              }}
              onClick={selectedValue === 1 ? handleExport1 : handleExport2}
            >
              <Image src={iconFile} />
              <Text fontSize="15px" fontWeight="600" color="var(--color-main)">
                Dữ liệu mẫu
              </Text>
            </Button>
          </Flex>
          <Flex justifyContent={"flex-start"}>
            <Button
              w={"100%"}
              h={"44px"}
              borderRadius={"8px"}
              fontSize={"15px"}
              color={"var(--color-main)"}
              fontWeight={"600"}
              colorScheme="red"
              onClick={handleDelete}
              bg="var(--linear-gradient-red)"
              _hover={{
                filter: "brightness(90%)",
              }}
            >
              Xóa
            </Button>
          </Flex>
        </Box>

        <DeleteDialog
          isOpen={isOpen}
          onClose={onClose}
          title={"Thông báo"}
          description={`chức năng này đang xây dựng!`}
          action={() => { }}
          isNotification={true}
        />
      </Flex>
    </Box>
  );
}
